<template>
  <div
    :class="[alert.type === 'success' ? 'bg-green-50' : 'bg-red-500']"
    class="p-4 rounded-md"
  >
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon
          v-if="alert.type === 'success'"
          class="w-5 h-5 text-green-400"
          aria-hidden="true"
        />
        <XCircleIcon v-else class="w-5 h-5 text-red-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <p
          :class="[alert.type === 'success' ? 'text-green-800' : 'text-white']"
          class="text-sm font-medium"
        >
          {{ alert.message }}
        </p>
      </div>
      <div class="pl-3 ml-auto">
        <div class="-mx-1.5 -my-1.5">
          <button
            type="button"
            @click="$emit('dismiss')"
            class="inline-flex bg-green-50 rounded-md p-1.5 text-green-500 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-green-50 focus:ring-green-600"
          >
            <span class="sr-only">Dismiss</span>
            <XIcon class="w-5 h-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon, XCircleIcon, XIcon } from "@heroicons/vue/solid";

export default {
  components: {
    XCircleIcon,
    CheckCircleIcon,
    XIcon,
  },
  props: {
    alert: {
      type: Object,
    },
  },
};
</script>
